import { Icon, Icons } from '@alphorm/ui'
import { createUseStyles } from 'react-jss'
import style from './style'

const useStyles = createUseStyles(style)

export default ({ PresentationVideoThumbnail, onVideoThumbnailClick }) => {
  const { bannerGroup, overlay, playSection, playIconGroup, playIcon } = useStyles({ PresentationVideoThumbnail })

  return (
    <div className={bannerGroup} onClick={(e) => onVideoThumbnailClick && onVideoThumbnailClick(e)}>
      <div className={overlay}>
        <div className={playSection} onClick={() => {}}>
          <div className={playIconGroup}><Icon iconName={Icons.play} style={playIcon} /></div>
        </div>
      </div>
    </div>
  )
}
